export enum EUserType {
  CITIZEN = 'CITIZEN',
  OTHER = 'OTHER',
}
